import { CoreAPI, createCommonAnalyticsMethods } from '@hero/sdk-core';

/**
 * Carrier SDK analytics — the shared common analytics methods
 * (`getMyAnalyticsOverview`, `getLeads`). All dashboard-tile
 * consumers should call `api.analytics.getMyAnalyticsOverview(...)`
 * for the unified overview.
 */
export function createAnalyticsAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonAnalyticsMethods(coreAPI),
  };
}
